<template>
  <div style="padding: 0 15px;">
    <!--左侧组织-->
    <div class="col_1 w240 left_height" style="height: 450px">
      <div style="padding-top: 20px;">
        <div class="tab_content">
          <div style="width: 240px;">
            <div v-if="!asyncFlag1" style="padding-top: 48px; text-align: center;">
              <xo-loader :type="'cube'" :color="['#ff3634']" :size="{width: '32px', height: '32px'}" :font="{fontSize: '12px'}" :text="'载入组织架构中...'"></xo-loader>
            </div>
            <div v-if="asyncFlag1 && options.boxStyle.width">
              <TreeView v-if="treemenu && treemenu.length > 0" :model="treemenu" @node-clicked="nodeClicked" :options="options"></TreeView>
              <h5 class="none_ts" v-else>
                <img src="@/assets/images/none_data.jpg" alt="">
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--/左侧组织-->
    <!--右侧已选组织和人员-->
    <div class="col_2 w365 right_height" style="height:450px;">
      <input style="opacity: 1; cursor: pointer;" type="radio" value="1" v-model="outputs.form.type" />
      全部重新计算
      <input style="opacity: 1; cursor: pointer;" type="radio" value="2"  v-model="outputs.form.type" />
      选中机构计算
      <dl v-if="outputs.form.type == '2'">
        <dt>已选择的部门<a href="javascript:void(0);" class="emptyBtn" @click="clear()">清空</a></dt>
        <dd class="right_content">
          <p :class="{ 'wangwei-icon': item.type === '04', '': item.type === '03', 'bumeng-icon': !item.type, 'tag-icon': item.tagType && item.tagType == '06' }" v-for="item in outputs.people" :key="item.id">
            <a href="javascript:void(0);" class="right_content_a">
              {{item.name}}
              <span @click="del(item)"></span>
            </a>
          </p>
        </dd>
      </dl>
    </div>
    <!--/右侧已选组织和人员-->
    <!--/右侧已选组织和人员-->
    <div class="clear"></div>
  </div>
</template>

<script>
  import TreeView  from '@/components/common/treeview/index.vue'
  import Paginate from 'vuejs-paginate'
  import utils from '@/utils'
  import difference from 'lodash.differenceby'
  import { mapState, mapActions, mapGetters } from 'vuex'
  export default {
    components: { TreeView, Paginate },
    created () {
      this.initData()
      if (this.params.inputs) {
        this.outputs.people = this.params.inputs
      }
      if (this.params.treeViewOptions) {
        this.options = this.params.treeViewOptions
      }
    },
    watch: {
      getCurrentDepts (val) { // 异步获取到的所有部门数据需要用watch
        this.treemenu = val
        this.options.selectedNodes = this.outputs.people.filter((val) => {
          return val.type !== '03'
        })
      },
      getDimension (val) {
        this.options.boxStyle.width = val.menusWidth
        this.options.depth = val.depth
      },
      'current': {
        handler (newVal, oldVal) {
          var l = this.outputs.people; // 深复制对象
          switch (newVal.name) {
            case 'org': {
              this.options.selectedNodes = l.filter((val) => {
                return val.type !== '03'
              })
              this.setSelected({sourcearr: l, targetarr: this.currentPeople, foundKey: 'id', targetMark: 'selected', targetVal: true})
              break
            }
          }
        },
        deep: true
      }
    },
    computed: {
      ...mapState('orgstructure', ['menus', 'dept', 'list']),
      ...mapGetters('orgstructure', ['getCurrentList', 'getCurrentDepts', 'getCurrentDept', 'getDimension']),
      ...mapGetters('users', ['getCurrentUsers', 'getCurrentRoles'])
    },
    props: ['params'],
    data () {
      var that = this
      return {
        menusWidth: '',
        asyncFlag1: false, // 加载标识1
        asyncFlag2: false, // 加载标识2
        pages: 0,
        cnt: 0,
        current: {},
        options: { // 树形菜单的Options
          parentNodeClickable: true, //  点击有子菜单的node是否可以发出事件
          multiselect: true, // 是否允许多选
          editMode: false, // 是否允许编辑/删除
          searchMode: true, // 是否提供过滤
          semiCheck: false, // 是否提供全选（选中父级则勾选中所有子级）
          hasScroll: true,
          boxStyle: {
            width: that.menusWidth,
            height: '420px'
          },
          nodeSelected: function (check, val) { // checkbox选中后的回调 check: checkbox是否被选中 val：节点的值
            if (val) {
              if (this.semiCheck && val.children) {
                var r = []
                r.push(val) // 要将点击的节点(自己)加入数组
                var result = utils.flattern(val.children) // 将数组里的children取出来拉平
                if (check) {
                  if (that.outputs.people && that.outputs.people.length > 0) { // 原来就有值
                    that.outputs.people = that.outputs.people.concat(r.concat(result))
                  } else {
                    that.outputs.people = r.concat(result)
                  }
                } else {
                  that.outputs.people = difference(that.outputs.people, r.concat(result), 'id')  // 求差集
                }
              } else { // 没有children的节点被点中
                that.itemChecked(check, val)
              }
            }
          },
          selectedNodes: that.params.inputs // 选中的节点，一般用于初始化
        },
        treemenu: [], // 该值在组件内部会监听变化的,只有改变这个值,树形菜单组件内部才会更新
        currentPeople: [],
        outputs: {
          people: [], // 选择的人
          form: {
            type: '2'
          }
        }
      }
    },
    methods: {
      ...mapActions('orgstructure', ['getDepts', 'addDept', 'delDept', 'getPersonByDept', 'setDept', 'addPerson']),
      ...mapActions('users', ['getUsers', 'getRoles']),
      initData () {
        return new Promise((resolve, reject) => {
          this.getDepts().then((r) => { // 异步获取部门信息 之后会默认去取部门下的人员
            this.asyncFlag1 = true
          })
        })
      },
      clickEffects (e) {
        var $elem = $(e.target)
        if ($elem.is('input')) {
          $elem.toggleClass('focus')
        }
      },
      itemChecked (check, item) {
        var idIndex = utils.findElem(this.outputs.people, 'id', item.id)
        if (check) {
          if (idIndex > -1) { /* 已存在的item不能再添加了 */
            return false;
          } else {
            this.outputs.people.push(item)
          }
        } else {
          this.outputs.people.splice(idIndex, 1)
        }
      },
      nodeClicked (node) { // 获取部门下面的人员
        this.setDept(node)
      },
      del (item) {
        var idx = utils.findElem(this.outputs.people, 'id', item.id)
        var t = item.type
        var tt = item.tagType
        this.outputs.people.splice(idx, 1)
        this.setSelected2(t, tt, item)
      },
      setSelected (o) {
        if (o.sourcearr.length > 0) {
          if (o.sourcearr.length < o.targetarr.length) { // !!!特殊情况
            utils.setVal(o.targetarr, o.targetMark, false)
          }
          for (let i = 0; i < o.sourcearr.length; i++) {
            let idx = utils.findElem(o.targetarr, o.foundKey, o.sourcearr[i][o.foundKey])
            if (idx > -1) {
              o.targetarr[idx][o.targetMark] = o.targetVal
            } else {
              if (o.targetarr[i]) {
                o.targetarr[i][o.targetMark] = !o.targetVal
              }
            }
          }
        } else {
          utils.setVal(o.targetarr, o.targetMark, false)
        }
      },
      setSelected2 (t, tt, item) {
        var _setTo = function (arr, key) {
          var idx = utils.findElem(arr, 'id', item.id)
          if (idx > -1) {
            arr[idx][key] = false
          }
        }
        if (t == '03') { // 更新人员选中状态
          _setTo(this.currentPeople, 'selected')
        } else { // 更新部门选中状态
          this.getDepts()
        }
      },
      checkedOne (item) {
        item.checked = !item.checked
        item.name = item.content
        item.tagType = '06'
        let idIndex =  this.$utils.findElem(this.outputs.people, 'id', item.id)
        if (idIndex >= 0) {
          this.outputs.people.splice(idIndex, 1)
        } else {
          this.outputs.people.push(item)
        }
      },
      clear () {
        this.outputs.people = [];
        this.options.selectedNodes = [];
        this.initData()
      }
    }
  }
</script>

<style scoped>
  @import './index.css';
</style>



// WEBPACK FOOTER //
// src/components/byl/rangeManip/onlyDepts.vue